import { render, staticRenderFns } from "./TheBrowserStats.vue?vue&type=template&id=7226f7b7&scoped=true&"
import script from "./TheBrowserStats.vue?vue&type=script&lang=js&"
export * from "./TheBrowserStats.vue?vue&type=script&lang=js&"
import style0 from "./TheBrowserStats.vue?vue&type=style&index=0&id=7226f7b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7226f7b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VChip,VProgressCircular,VSpacer})
